import PropTypes from 'prop-types';
import { Wrapper } from "./styles";
import ErrorImage from '../../../assets/images/ErrorImage.svg'

const ErrorTemplate = ({ errorCode, title, children, image = ErrorImage, imageClassName, actions }) => {
  return (
    <Wrapper>
      <img data-testid="error-image" className={imageClassName} src={image} alt={errorCode}></img>
      <p data-testid="error-title" className="error-title">{title}</p>
      <div data-testid="error-message">
        {children}
      </div>
      {actions && (
        <div data-testid="error-actions" className="error-actions">
          {actions}
        </div>
      )}
    </Wrapper>
  );
};

ErrorTemplate.propTypes = {
  errorCode: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.element,
  image: PropTypes.string,
  imageClassName: PropTypes.string,
  actions: PropTypes.node,
};

export default ErrorTemplate;
